import { render } from "./CourseSelect.vue?vue&type=template&id=16d0b3b6"
import script from "./CourseSelect.vue?vue&type=script&lang=js"
export * from "./CourseSelect.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__